import { cloudCover, rainOptions, visibilitySelector, windDirectionsSpanish, windSpeed } from "../../utils/SelectorMapping";
import CustomSelect from "../forms/CustomSelect";

interface WeatherSelectorsProps {
    formik: any;
    required?: boolean;
    visibility?: boolean;
    syncCalmWind?: boolean;
    excludeCalmIntensity?: boolean;
    /** Censo/líneas: D_Vto e I_Vto antes que visibilidad y lluvia */
    windFieldsFirst?: boolean;
}

const WeatherSelectors: React.FC<WeatherSelectorsProps> = ({
    formik,
    required = true,
    visibility = false,
    syncCalmWind = false,
    excludeCalmIntensity = false,
    windFieldsFirst = false,
}) => {
    const windSpeedOptions = excludeCalmIntensity
        ? windSpeed.filter((option) => option.value !== '0')
        : windSpeed;

    const windDirectionSelect = (
        <CustomSelect
            isSearchable
            id={'windDirection'}
            label="D_Vto"
            info="Dirección del viento"
            options={windDirectionsSpanish}
            onChange={(e: any) => {
                formik.setFieldValue('windDirection', e.value);
                if (syncCalmWind && e.value === 'CALMA') {
                    formik.setFieldValue('windSpeed', '0');
                }
            }}
            value={
                formik.values.windDirection !== null && formik.values.windDirection !== undefined
                    ? windDirectionsSpanish.find((option) => option.value == formik.values.windDirection)
                    : null
            }
            required={required}
            error={formik.errors.windDirection && formik.touched.windDirection ? formik.errors.windDirection : undefined}
        />
    );

    const windSpeedSelect = (
        <CustomSelect
            isSearchable
            id={'windSpeed'}
            label="I_Vto"
            info="Intensidad del viento"
            options={windSpeedOptions}
            onChange={(e: any) => {
                formik.setFieldValue('windSpeed', e.value);
                if (syncCalmWind && e.value === '0') {
                    formik.setFieldValue('windDirection', 'CALMA');
                }
            }}
            value={
                formik.values.windSpeed !== null && formik.values.windSpeed !== undefined
                    ? windSpeedOptions.find((option) => option.value == formik.values.windSpeed)
                    : null
            }
            required={required}
            error={formik.errors.windSpeed && formik.touched.windSpeed ? formik.errors.windSpeed : undefined}
        />
    );

    const cloudCoverageSelect = (
        <CustomSelect
            isSearchable
            id={'cloudCoverage'}
            label="Cob"
            info="Cobertura de nubes"
            options={cloudCover}
            onChange={(e: any) => {
                formik.setFieldValue('cloudCoverage', e.value);
            }}
            value={
                formik.values.cloudCoverage !== null && formik.values.cloudCoverage !== undefined
                    ? cloudCover.find((option) => option.value == formik.values.cloudCoverage)
                    : null
            }
            required={required}
            error={formik.errors.cloudCoverage && formik.touched.cloudCoverage ? formik.errors.cloudCoverage : undefined}
        />
    );

    const rainSelect = (
        <CustomSelect
            isSearchable
            id={'rain'}
            label="Lluvia"
            info="Lluvia"
            options={rainOptions}
            onChange={(e: any) => {
                formik.setFieldValue('rain', e.value);
            }}
            value={
                formik.values.rain !== null && formik.values.rain !== undefined
                    ? rainOptions.find((option) => option.value == formik.values.rain)
                    : null
            }
            required={visibility}
            error={formik.errors.rain && formik.touched.rain ? formik.errors.rain : undefined}
            display={visibility}
        />
    );

    const visibilitySelect = (
        <CustomSelect
            isSearchable
            id={'visibility'}
            label="Visibilidad"
            info="Visibilidad"
            options={visibilitySelector}
            onChange={(e: any) => {
                formik.setFieldValue('visibility', e.value);
            }}
            value={
                formik.values.visibility !== null && formik.values.visibility !== undefined
                    ? visibilitySelector.find((option) => option.value == formik.values.visibility)
                    : null
            }
            required={visibility}
            error={visibility && formik.touched.visibility ? formik.errors.visibility : undefined}
            display={visibility}
        />
    );

    const fields = (() => {
        const windFields = [windDirectionSelect, windSpeedSelect, cloudCoverageSelect];
        if (!visibility) {
            return windFields;
        }
        if (windFieldsFirst) {
            return [...windFields, rainSelect, visibilitySelect];
        }
        return [visibilitySelect, rainSelect, ...windFields];
    })();

    return (
        <div className={`${visibility ? 'grid md:grid-cols-5 grid-cols-1 gap-4' : 'grid md:grid-cols-3 grid-cols-1 gap-4'}`}>
            {fields.map((field, index) => (
                <div key={index}>{field}</div>
            ))}
        </div>
    );
};

export default WeatherSelectors;
